module.exports = __webpack_public_path__ + "static/img/AI穿透式监管方案_架构图.1a68bdaa.png";